import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import pipaanlogo from "../../assets/pipaanlogo.png";
import profileimg from "../../assets/profile.png";
import newsfeed from "../../assets/images/icons/newsfeed.svg";
import friendsfollowers from "../../assets/images/icons/friendsandfollowers.svg";
import groupsandfamily from "../../assets/images/icons/groupandfamily.svg";
import chats from "../../assets/images/icons/chats.svg";
import profile from "../../assets/images/icons/profile.svg";
import Account from "../../assets/images/icons/account-setting.svg";
import help from "../../assets/images/icons/helpandsupport.svg";
import logout from "../../assets/images/icons/logout.svg";
import heartmenu from "../../assets/images/icons/heart-menu.svg";
import walletmenu from "../../assets/images/icons/wallet-menu.svg";
import artiststudiomenu from "../../assets/images/icons/microphone.png";
import marketmenu from "../../assets/images/icons/market.svg";
import aboutusmenu from "../../assets/images/icons/aboutus-menu.svg";
import becomesellermenu from "../../assets/images/icons/becomeseller-menu.svg";
import sellerordermenu from "../../assets/images/icons/sellerorder-menu.svg";
import musicmenu from "../../assets/images/icons/music-menu.svg";
import adsmenu from "../../assets/images/icons/marketing.svg";
import billmenu from "../../assets/images/icons/billing/bill.svg";
import MarketplaceCartLink from "../common/MarketplaceCartLink";
import Notification from "../common/Notification";
import hamburger from "../../assets/images/icons/hamburger.png";
import hamburgerclose from "../../assets/images/icons/hamburgerclose.png";
import { performLogout } from "../../utils/auth";

const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

// Same keys the desktop sidebar uses for the unread chats badge.
const CHAT_UNREAD_KEY = "chatUnreadCount";
const CHAT_UNREAD_EVENT = "chat-unread-changed";

const readChatUnread = () => {
    try {
        const cached = JSON.parse(sessionStorage.getItem(CHAT_UNREAD_KEY) || "null");
        return cached && typeof cached.count === "number" ? cached.count : 0;
    } catch (e) {
        return 0;
    }
};

const readUser = () => {
    try {
        const raw = sessionStorage.getItem("user") || localStorage.getItem("user");
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
};

const readPhoto = () => sessionStorage.getItem("profilePictureUrl") || localStorage.getItem("profilePictureUrl") || profileimg;

// Subscriptions has no icon file yet, so it gets a small star drawn here.
const StarIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 3l2.8 5.7 6.2.9-4.5 4.4 1.1 6.2L12 17.2 6.4 20.2l1.1-6.2L3 9.6l6.2-.9L12 3z" />
    </svg>
);

// The same places the desktop sidebar offers, so nothing on the web is missing on a phone.
const buildMenu = ({ hasSellerProfile }) => [
    {
        title: "Browse",
        items: [
            { href: "/home", label: "News Feeds", icon: newsfeed, active: (p) => p === "/home" },
            { href: "/fan/home", label: "Music", icon: musicmenu, active: (p) => p.startsWith("/fan/home") },
            { href: "/friendsfollowers", label: "Friends & Followers", icon: friendsfollowers, active: (p) => p === "/friendsfollowers" },
            { href: "/groupsfamily", label: "Groups & Family", icon: groupsandfamily, active: (p) => p === "/groupsfamily" },
            { href: "/chats", label: "Chats", icon: chats, badge: "chat", active: (p) => p === "/chats" },
        ],
    },
    {
        title: "You",
        items: [
            { href: "/myprofile", label: "Profile", icon: profile, active: (p) => p === "/myprofile" },
            { href: "/donation", label: "Donation", icon: heartmenu, active: (p) => p === "/donation" },
            { href: "/fan-membership", label: "Subscriptions", iconNode: <StarIcon />, active: (p) => p.startsWith("/fan-membership") },
            { href: "/wallet", label: "Wallet", icon: walletmenu, active: (p) => p === "/wallet" },
        ],
    },
    {
        title: "Create & sell",
        items: [
            { href: "/artist-studio", label: "Artist Studio", icon: artiststudiomenu, active: (p) => p.startsWith("/artist-studio") },
            { href: "/marketplace", label: "Market Place", icon: marketmenu, active: (p) => p === "/marketplace" },
            { href: "/ads", label: "Ads Campaign", icon: adsmenu, active: (p) => p.startsWith("/ads") && !p.startsWith("/ads/billing") },
            { href: "/ads/billing", label: "Billing & Information", icon: billmenu, active: (p) => p.startsWith("/ads/billing") },
            ...(hasSellerProfile ? [{ href: "/ordermanagement", label: "Seller Order Management", icon: sellerordermenu, active: (p) => p === "/ordermanagement" }] : []),
            { href: "/sellProfile", label: hasSellerProfile ? "Seller Profile" : "Become a Seller", icon: becomesellermenu, active: (p) => p === "/sellProfile" },
        ],
    },
    {
        title: "Account",
        items: [
            { href: "/account", label: "Account Settings", icon: Account, active: (p) => p === "/account" },
            { href: "/help", label: "Help & Support", icon: help, active: (p) => p === "/help" },
            { href: "/aboutus", label: "About Us", icon: aboutusmenu, active: (p) => p === "/aboutus" },
        ],
    },
];

export default function LeftResponsivesidebar() {
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const [me, setMe] = useState(readUser);
    const [photo, setPhoto] = useState(readPhoto);
    const [chatUnread, setChatUnread] = useState(readChatUnread);
    const [hasSellerProfile, setHasSellerProfile] = useState(false);

    const close = useCallback(() => setIsOpen(false), []);

    // Keep the person's own name, photo and unread count current.
    useEffect(() => {
        const refresh = () => { setMe(readUser()); setPhoto(readPhoto()); };
        const onUnread = (e) => setChatUnread(Number(e.detail) || 0);
        window.addEventListener("profilePictureUpdated", refresh);
        window.addEventListener("storage", refresh);
        window.addEventListener(CHAT_UNREAD_EVENT, onUnread);
        return () => {
            window.removeEventListener("profilePictureUpdated", refresh);
            window.removeEventListener("storage", refresh);
            window.removeEventListener(CHAT_UNREAD_EVENT, onUnread);
        };
    }, []);

    // Same seller check the desktop sidebar makes, so "Become a Seller" / "Seller Profile" read correctly.
    useEffect(() => {
        const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
        if (!token) return undefined;
        const controller = new AbortController();
        (async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/seller/get-seller-profile`, {
                    method: "POST",
                    headers: { token, "Content-Type": "application/json" },
                    body: JSON.stringify({}),
                    signal: controller.signal,
                });
                if (!response.ok) return;
                const data = await response.json();
                if (!controller.signal.aborted) setHasSellerProfile(Boolean(data.success && data.result?.id));
            } catch (e) {
                // Leave the seller entries on their default wording when the profile cannot be checked.
            }
        })();
        return () => controller.abort();
    }, []);

    // While the menu is open: Escape closes it, the page behind does not scroll, and a wide screen shuts it.
    useEffect(() => {
        if (!isOpen) return undefined;
        const onKey = (e) => { if (e.key === "Escape") close(); };
        const onResize = () => { if (window.innerWidth >= 1024) close(); };
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        window.addEventListener("keydown", onKey);
        window.addEventListener("resize", onResize);
        return () => {
            document.body.style.overflow = previousOverflow;
            window.removeEventListener("keydown", onKey);
            window.removeEventListener("resize", onResize);
        };
    }, [isOpen, close]);

    // Moving to another page always closes the menu.
    useEffect(() => { close(); }, [location.pathname, close]);

    const myName = me ? `${me.first_name || ""} ${me.last_name || ""}`.trim() : "";
    const sections = buildMenu({ hasSellerProfile });
    const path = location.pathname;

    return (
        <>
            <header className="flex items-center justify-between pb-8 lg:hidden">
                {/* Logo */}
                <a href="/home" className="flex items-center space-x-3" aria-label="Nyawoo home">
                    <img src={pipaanlogo} alt="Nyawoo Logo" className="md:w-30 md:h-30 w-[75px] h-[60px]" />
                </a>

                {/* Notifications, cart, profile and the menu button */}
                <div className="flex items-center space-x-4">
                    <Notification />
                    <MarketplaceCartLink />
                    <a href="/myprofile" className="profile-dashboard rounded-full overflow-hidden" aria-label="My profile">
                        <img src={photo} alt="Profile" className="w-full h-full object-cover" />
                    </a>
                    <button
                        type="button"
                        className="lg:hidden p-2 rounded-md"
                        onClick={() => setIsOpen((open) => !open)}
                        aria-label={isOpen ? "Close menu" : "Open menu"}
                        aria-expanded={isOpen}
                        aria-controls="mobile-menu"
                    >
                        <img src={isOpen ? hamburgerclose : hamburger} alt="" className="w-6 h-6 object-cover" />
                    </button>
                </div>
            </header>

            {/* Tapping anywhere outside the menu closes it */}
            {isOpen && (
                <div className="fixed inset-0 z-[990] bg-black/40 lg:hidden" onClick={close} aria-hidden="true" data-testid="menu-backdrop" />
            )}

            {/* Menu drawer */}
            <div
                id="mobile-menu"
                role="dialog"
                aria-modal="true"
                aria-label="Menu"
                className={`mobile-drawer fixed top-0 left-0 z-[991] h-full w-[85vw] max-w-[340px] bg-white shadow-2xl overflow-y-auto overflow-x-hidden transition-transform duration-300 lg:hidden ${isOpen ? "translate-x-0" : "-translate-x-full invisible"}`}
            >
                <div className="flex items-center justify-between px-5 pt-5">
                    <img src={pipaanlogo} alt="Nyawoo" className="w-[75px] h-[48px] object-contain" />
                    <button type="button" onClick={close} aria-label="Close menu" className="p-2 rounded-md">
                        <img src={hamburgerclose} alt="" className="w-6 h-6" />
                    </button>
                </div>

                <a href="/myprofile" className="flex flex-col items-center px-5 pt-4 pb-5 text-center">
                    <span className="profile-dashboard rounded-full overflow-hidden block">
                        <img src={photo} alt="Profile" className="w-full h-full object-cover" />
                    </span>
                    <span className="mt-2 font-semibold break-words max-w-full">{myName || "Your profile"}</span>
                    {me?.username && <span className="text-sm text-gray-500 break-all">@{me.username}</span>}
                </a>

                <nav className="px-4 pb-10" aria-label="Main menu">
                    {sections.map((section) => (
                        <div key={section.title} className="mb-3">
                            <p className="px-3 pb-1 text-xs font-semibold uppercase tracking-wide text-gray-400">{section.title}</p>
                            {section.items.map((item) => {
                                const active = item.active(path);
                                return (
                                    <a
                                        key={item.href + item.label}
                                        href={item.href}
                                        onClick={close}
                                        aria-current={active ? "page" : undefined}
                                        className={`mobile-drawer-link flex items-center gap-3 rounded-xl px-3 py-3 text-[15px] ${active ? "bg-[#161f28] text-white" : "text-[#161f28] hover:bg-gray-100"}`}
                                    >
                                        {item.iconNode ? (
                                            <span className="w-6 h-6 flex items-center justify-center flex-none">{item.iconNode}</span>
                                        ) : (
                                            <img src={item.icon} alt="" className={`w-6 h-6 flex-none object-contain ${active ? "brightness-0 invert" : ""}`} />
                                        )}
                                        <span className="min-w-0 flex-1 break-words">{item.label}</span>
                                        {item.badge === "chat" && chatUnread > 0 && (
                                            <span className="ml-auto min-w-[22px] h-[22px] px-1.5 rounded-full bg-[#095228] text-white text-xs font-bold flex items-center justify-center">
                                                {chatUnread > 99 ? "99+" : chatUnread}
                                            </span>
                                        )}
                                    </a>
                                );
                            })}
                        </div>
                    ))}

                    <a
                        href="/login"
                        onClick={(e) => { e.preventDefault(); close(); performLogout(); }}
                        className="mobile-drawer-link flex items-center gap-3 rounded-xl px-3 py-3 text-[15px] text-red-600 hover:bg-red-50"
                    >
                        <img src={logout} alt="" className="w-6 h-6 flex-none object-contain" />
                        <span>Logout</span>
                    </a>
                </nav>
            </div>
        </>
    );
}
